import React, {Component} from 'react';
import {withRouter} from "../../hoc/withRouter";
import {Breadcrumb, Col, Row, Input, Button, Checkbox, Form, Divider, Upload, Modal, Alert, Radio, Space} from "antd";
import FooterSection from "../../component/pageSection/FooterSection";
import PageHeader from "../../component/header/PageHeader";
import {appDefaultArea} from "../../config/appDataConfig/appConfig";
import Cookies from "universal-cookie";
import {appName} from "../../config/appDataConfig/appConfig";
import AreaProvinceSelect from "../../component/area/AreaProvinceSelect";
import AreaCitySelect from "../../component/area/AreaCitySelect";
import UploadOutlined from "@ant-design/icons/UploadOutlined";
import {baseUrlCdnUpload} from "../../config/apiConfig/apiConfig";
import "./formEvTaxi.css";
import {bqBridgingService} from "../../services/BqBridging/BqBridgingService";

class FormEvTaxi extends Component<any, any> {
    private cookies = new Cookies();
    private readonly initState!: any;
    private locationCheckInterval: any;

    constructor(props: any) {
        super(props);

        if (!this.cookies.get('_amc-a')) {
            this.cookies.set('_amc-a', appDefaultArea);
        }

        this.initState = {
            isDesktop: false,
            areaCode: (this.cookies.get('_amc-a')) ? this.cookies.get('_amc-a') : appDefaultArea,
            lat: this.cookies.get('_lat') || "",
            lng: this.cookies.get('_lng') || "",
            
            fullName: "",
            provinceCode: "",
            provinceName: null,
            cityCode: "",
            cityName: null,
            whatsappNumber: "",
            email: "",
            
            // Platform checkboxes
            platformGrabCar: false,
            platformGoCar: false,
            platformMaxim: false,
            platformInDrive: false,
            platformOthers: false,
            platformOffline: false,
            
            // Skema sewa dropdown
            selectedScheme: null,
            
            pendapatanMingguanUrl: "",
            isUploading: false,
            isSubmitting: false
        }
        this.state = {...this.initState}
    }

    handleResize = () => {
        if (window.innerWidth < 992) {
            this.setState({
                isDesktop: false,
            });
        } else {
            this.setState({
                isDesktop: true,
            });
        }
    }

    onAreaChange = async (data: any) => {
        this.cookies.set('_amc-a', data.city_group);
        await this.promisedSetState({
            areaCode: data.city_group,
        });
    }

    componentDidMount() {

        window.location.href = "https://amtrix.me";
        return;

        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 10);

        window.addEventListener("resize", this.handleResize.bind(this));
        this.handleResize();
        
        // Inisialisasi tracking lokasi
        this.initLocationTracking();
        this.locationCheckInterval = setInterval(this.checkLocation, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
        if (this.locationCheckInterval) {
            clearInterval(this.locationCheckInterval);
        }
    }
    
    initLocationTracking = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    this.cookies.set('_lat', lat);
                    this.cookies.set('_lng', lng);
                    this.setState({ lat, lng });
                },
                (error) => {
                    console.error("Error obtaining location: ", error);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }
    
    checkLocation = () => {
        const lat = this.cookies.get('_lat');
        const lng = this.cookies.get('_lng');
        if (lat && lng && !this.state.lat) {
            this.setState({ lat, lng });
        }
    }

    componentDidUpdate() {
        // Tambahkan styling untuk select setiap kali komponen update
        const selectElements = document.querySelectorAll('.select-container .ant-select');
        selectElements.forEach((element: any) => {
            if (element) {
                element.style.width = '100%';
            }
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    onFieldChange = <T extends keyof Pick<any, "fullName" | "whatsappNumber" | "email">>(target: T, value: any) => {
        const currentState: any = {...this.state}
        switch (target) {
            case "fullName":
                currentState.fullName = value
                break
            case "whatsappNumber":
                // Hanya menerima angka
                value = value.replace(/[^0-9]/g, '')
                // Validasi format 08xx
                if (value.length >= 2 && value.substring(0, 2) !== '08') {
                    value = value.substring(0, 1)
                }
                // Batasi panjang nomor
                if (value.length > 13) {
                    value = value.substring(0, 13)
                }
                currentState.whatsappNumber = value
                break
            case "email":
                currentState.email = value
                break
        }

        this.setState({
            ...currentState,
        })
    }

    onAreaProvinceChange = (data: any) => {
        this.setState({
            provinceCode: data.value,
            provinceName: data.children,
            cityCode: "",
            cityName: null,
        })
    }

    onAreaCityChange = (data: any) => {
        this.setState({
            cityCode: data.value,
            cityName: data.children
        })
    }

    onPlatformChange = (platform: string, checked: boolean) => {
        const stateKey = `platform${platform}`;
        this.setState({
            [stateKey]: checked
        });
    }

    onSchemeChange = (value: string) => {
        this.setState({
            selectedScheme: value
        });
    }

    uploadImageChange = (data: any) => {
        console.log("Upload event:", data);
        
        if (data?.file?.status === "done") {
            console.log("Upload response:", data?.file?.response);
            
            // Cek berbagai kemungkinan struktur response
            let newDocUrl;
            if (data?.file?.response?.data?.url_document) {
                newDocUrl = data?.file?.response?.data?.url_document;
                console.log("URL from url_document:", newDocUrl);
            } else if (data?.file?.response?.data?.Location) {
                newDocUrl = data?.file?.response?.data?.Location;
                console.log("URL from Location:", newDocUrl);
            } else if (typeof data?.file?.response?.data === 'string') {
                newDocUrl = data?.file?.response?.data;
                console.log("URL from data string:", newDocUrl);
            }
            
            this.setState({
                pendapatanMingguanUrl: newDocUrl || "",
                isUploading: false
            });
        }
        if (data?.file?.status === "uploading") {
            this.setState({
                isUploading: true
            });
        }
        if (data?.file?.status === "removed") {
            this.setState({
                pendapatanMingguanUrl: "",
                isUploading: false
            });
        }
        if (data?.file?.status === "error") {
            console.error("Upload error:", data?.file?.error);
            Modal.error({
                title: 'Upload Gagal',
                content: 'Terjadi kesalahan saat mengupload gambar.'
            });
            this.setState({
                isUploading: false
            });
        }
    }

    validateForm = () => {
        let isValid = true;
        let errorMessage = "";

        if (!this.state.fullName) {
            isValid = false;
            errorMessage += "Nama lengkap, ";
        }
        if (!this.state.provinceCode) {
            isValid = false;
            errorMessage += "Provinsi, ";
        }
        if (!this.state.cityCode) {
            isValid = false;
            errorMessage += "Kota/Kabupaten, ";
        }
        if (!this.state.whatsappNumber || this.state.whatsappNumber.length < 10) {
            isValid = false;
            errorMessage += "Nomor WhatsApp (minimal 10 digit), ";
        }
        if (!this.state.email || !this.validateEmail(this.state.email)) {
            isValid = false;
            errorMessage += "Email, ";
        }

        // Check if at least one platform is selected
        const anyPlatformSelected = this.state.platformGrabCar || this.state.platformGoCar || 
                                   this.state.platformMaxim || this.state.platformInDrive || 
                                   this.state.platformOthers || this.state.platformOffline;
        if (!anyPlatformSelected) {
            isValid = false;
            errorMessage += "Platform saat ini, ";
        }

        // Check if scheme is selected
        if (!this.state.selectedScheme) {
            isValid = false;
            errorMessage += "Skema sewa, ";
        }

        if (!this.state.pendapatanMingguanUrl) {
            isValid = false;
            errorMessage += "Gambar pendapatan mingguan, ";
        }
        
        if (!this.state.lat || !this.state.lng) {
            isValid = false;
            errorMessage += "mohon izinkan allow location pada browser, ";
        }

        return { isValid, errorMessage };
    }

    validateEmail = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return regex.test(email)
    }

    onSubmitForm = async () => {
        const { isValid, errorMessage } = this.validateForm();
        
        if (!isValid) {
            Modal.error({
                title: 'Proses Gagal',
                content: (<div>
                    Mohon Lengkapi data-data berikut: <br/><br/>
                    {errorMessage.split(",").map(function (itemError, i) {
                        return itemError ? <div key={i}>{itemError}</div> : null;
                    })}
                </div>)
            });
            return;
        }

        // Collect platform list
        const selectedPlatforms = [];
        if (this.state.platformGrabCar) selectedPlatforms.push("GRAB CAR");
        if (this.state.platformGoCar) selectedPlatforms.push("GOCAR");
        if (this.state.platformMaxim) selectedPlatforms.push("MAXIM");
        if (this.state.platformInDrive) selectedPlatforms.push("INDRIVE");
        if (this.state.platformOthers) selectedPlatforms.push("LAIN-LAIN");
        if (this.state.platformOffline) selectedPlatforms.push("OFFLINE");

        // Collect scheme list dengan format yang lebih detail
        const selectedSchemes = [];
        if (this.state.selectedScheme === "VF5_SEWA_PER_MINGGU") {
            selectedSchemes.push({
                key: "VF5_SEWA_PER_MINGGU",
                value: "VF5 SEWA PER MINGGU Rp 1.850.000 (deposit 4 minggu di depan) (265.000 per hari)"
            });
        } else if (this.state.selectedScheme === "VF5_SEWA_PER_BULAN") {
            selectedSchemes.push({
                key: "VF5_SEWA_PER_BULAN",
                value: "VF5 SEWA PER BULAN Rp 7.000.000 (deposit 1 bulan di depan) (230.000 per hari)"
            });
        } else if (this.state.selectedScheme === "VF5_SEWA_MILIK") {
            selectedSchemes.push({
                key: "VF5_SEWA_MILIK",
                value: "VF5 SEWA MILIK Rp 8.000.000 (unit tenor 48 bulan DP mulai di Rp 24.000.000) (266.000 per hari)"
            });
        } else if (this.state.selectedScheme === "VFE34_SEWA_PER_BULAN") {
            selectedSchemes.push({
                key: "VFE34_SEWA_PER_BULAN",
                value: "VFE34 SEWA PER BULAN Rp 8.500.000 (deposit 1 bulan di depan) (280.000 per hari)"
            });
        } else if (this.state.selectedScheme === "VFE34_SEWA_MILIK") {
            selectedSchemes.push({
                key: "VFE34_SEWA_MILIK",
                value: "VFE34 SEWA MILIK Rp 9.500.000 (tenor 48 bulan DP mulai di Rp 34.000.000) (266.000 per hari)"
            });
        }

        // Prepare data object dengan format snake_case
        const formData = {
            full_name: this.state.fullName?.toUpperCase(),
            province_code: this.state.provinceCode,
            province_name: this.state.provinceName,
            city_code: this.state.cityCode,
            city_name: this.state.cityName,
            whatsapp_number: this.state.whatsappNumber,
            email: this.state.email?.toLowerCase(),
            platforms: selectedPlatforms,
            schemes: selectedSchemes,
            weekly_income_url: this.state.pendapatanMingguanUrl,
            location: {
                latitude: this.state.lat,
                longitude: this.state.lng
            }
        };

        // Set loading state
        this.setState({ isSubmitting: true });

        try {
            // Kirim data ke BqBridging
            await bqBridgingService.storeData(formData);
            
            // Reset form ke state awal
            this.setState({
                ...this.initState,
                areaCode: this.state.areaCode, // Pertahankan areaCode
                lat: this.state.lat, // Pertahankan lat
                lng: this.state.lng, // Pertahankan lng
                isDesktop: this.state.isDesktop // Pertahankan isDesktop
            });

            // Tampilkan modal sukses
            Modal.success({
                title: 'Terima Kasih',
                content: (
                    <div>
                        <p>Data Anda telah berhasil disimpan.</p>
                        <p>Tim kami akan segera menghubungi Anda melalui WhatsApp untuk proses selanjutnya.</p>
                    </div>
                ),
                okText: 'Tutup',
                onOk: () => {
                    // Scroll ke atas halaman
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
            });

        } catch (error) {
            // Tampilkan error jika gagal
            Modal.error({
                title: 'Gagal Menyimpan Data',
                content: 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.'
            });
            console.error('Error submitting form:', error);
        } finally {
            // Reset loading state
            this.setState({ isSubmitting: false });
        }
    }

    render() {
        // return (
        //     <div style={{ textAlign: "center", marginTop: "30vh" }}>
        //         <h3>Mengarahkan ke Amtrix...</h3>
        //     </div>
        // );

        // Custom styles
        const formItemStyle = {
            marginBottom: '15px'
        };

        const selectWrapperStyle = {
            width: '100%'
        };

        return (
            <>
                <PageHeader black={true} onAreaChangeProps={this.onAreaChange} areaCode={this.state.areaCode} isDesktop={this.state.isDesktop}/>

                <Row className={`pt-100`}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <Breadcrumb className={`pl-20`}>
                            <Breadcrumb.Item>Amarta {appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>Form Amarta Vinfast Driver Taxi Listrik</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row className={`p-20 mt-20`} style={{backgroundColor: "#fff"}}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <div>
                            <div style={{textAlign: "center", fontSize: "170%", marginBottom: 7}}>Pendaftaran Driver Taxi Listrik</div>
                            <div style={{textAlign: "center", fontSize: "100%", marginBottom: 20, color: "gray"}}>Silakan isi data diri Anda pada form di bawah ini</div>
                        </div>
                        
                        <Alert
                            message="Allow Access Location"
                            description={(this.state.lat && this.state.lng) ? 'Location Ok, silakan lanjut pengisian data' : 'Sebelum melakukan pengisian mohon izinkan Allow Location Permission pada browser.'}
                            type="info"
                            showIcon
                            style={{marginBottom: 20}}
                        />

                        <Form layout="vertical" className="ev-taxi-form">
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nama Lengkap *</i>
                                        <Input 
                                            value={this.state.fullName} 
                                            onChange={event => this.onFieldChange("fullName", event.target.value)} 
                                            placeholder="Masukan Nama Lengkap"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nomor WhatsApp *</i>
                                        <Input
                                            value={this.state.whatsappNumber}
                                            maxLength={17}
                                            placeholder="Format: 08xxxxxxxx"
                                            onChange={event => this.onFieldChange("whatsappNumber", event.target.value)}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Provinsi *</i>
                                        <div style={selectWrapperStyle}>
                                            <AreaProvinceSelect 
                                                onAreaProvinceChangeProps={this.onAreaProvinceChange} 
                                                country={"idn"} 
                                                provinceName={this.state.provinceName}
                                            />
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Kota/Kabupaten *</i>
                                        <div style={selectWrapperStyle}>
                                            <AreaCitySelect 
                                                onAreaCityChangeProps={this.onAreaCityChange} 
                                                provinceCode={this.state.provinceCode} 
                                                cityName={this.state.cityName}
                                            />
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Email *</i>
                                        <Input
                                            value={this.state.email}
                                            placeholder="contoh@email.com"
                                            onChange={event => this.onFieldChange("email", event.target.value)}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider orientation="left" plain>
                                <span style={{fontSize: '16px', color: '#384967', fontWeight: 500}}>Platform Saat Ini</span>
                            </Divider>
                            <Row style={{marginBottom: '25px'}}>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 15}}>
                                    <Checkbox onChange={e => this.onPlatformChange('GrabCar', e.target.checked)} checked={this.state.platformGrabCar}>
                                        GRAB CAR
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 15}}>
                                    <Checkbox onChange={e => this.onPlatformChange('GoCar', e.target.checked)} checked={this.state.platformGoCar}>
                                        GOCAR
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 15}}>
                                    <Checkbox onChange={e => this.onPlatformChange('Maxim', e.target.checked)} checked={this.state.platformMaxim}>
                                        MAXIM
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 15}}>
                                    <Checkbox onChange={e => this.onPlatformChange('InDrive', e.target.checked)} checked={this.state.platformInDrive}>
                                        INDRIVE
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 15}}>
                                    <Checkbox onChange={e => this.onPlatformChange('Others', e.target.checked)} checked={this.state.platformOthers}>
                                        LAIN-LAIN
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 15}}>
                                    <Checkbox onChange={e => this.onPlatformChange('Offline', e.target.checked)} checked={this.state.platformOffline}>
                                        OFFLINE
                                    </Checkbox>
                                </Col>
                            </Row>

                            <Divider orientation="left" plain>
                                <span style={{fontSize: '16px', color: '#384967', fontWeight: 500}}>Skema Sewa Yang Diminati</span>
                            </Divider>
                            <Row style={{marginBottom: '25px'}}>
                                <Col xl={{span: 24}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <div style={{
                                        backgroundColor: '#f8f9fa',
                                        padding: '20px',
                                        borderRadius: '8px',
                                        border: '1px solid #e9ecef'
                                    }}>
                                        <Radio.Group 
                                            onChange={(e) => this.onSchemeChange(e.target.value)} 
                                            value={this.state.selectedScheme}
                                            style={{width: '100%'}}
                                        >
                                            <Space direction="vertical" style={{width: '100%', gap: '20px'}}>
                                                {/* VF 5 Section */}
                                                <div style={{
                                                    backgroundColor: '#fff',
                                                    padding: '15px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #e6e6e6'
                                                }}>
                                                    <div style={{
                                                        fontSize: '16px',
                                                        fontWeight: 600,
                                                        color: '#384967',
                                                        marginBottom: '10px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px'
                                                    }}>
                                                        VF 5
                                                        <a 
                                                            href="https://amartavinfast.com/variant/VF5_4X2_AT_WI_BAT" 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                fontSize: '12px',
                                                                color: '#1890ff',
                                                                textDecoration: 'none'
                                                            }}
                                                        >
                                                            (Lihat Produk)
                                                        </a>
                                                    </div>
                                                    <Space direction="vertical" style={{width: '100%'}}>
                                                        <Radio value="VF5_SEWA_PER_MINGGU">
                                                            <div style={{fontSize: '14px', color: '#384967', lineHeight: '1.5'}}>
                                                                <div style={{fontWeight: 500}}>SEWA PER MINGGU</div>
                                                                <div style={{fontSize: '13px', color: '#666'}}>
                                                                    Rp 1.850.000 (deposit 4 minggu di depan) (265.000 per hari)
                                                                </div>
                                                            </div>
                                                        </Radio>
                                                        <Radio value="VF5_SEWA_PER_BULAN">
                                                            <div style={{fontSize: '14px', color: '#384967', lineHeight: '1.5'}}>
                                                                <div style={{fontWeight: 500}}>SEWA PER BULAN</div>
                                                                <div style={{fontSize: '13px', color: '#666'}}>
                                                                    Rp 7.000.000 (deposit 1 bulan di depan) (230.000 per hari)
                                                                </div>
                                                            </div>
                                                        </Radio>
                                                        <Radio value="VF5_SEWA_MILIK">
                                                            <div style={{fontSize: '14px', color: '#384967', lineHeight: '1.5'}}>
                                                                <div style={{fontWeight: 500}}>SEWA MILIK</div>
                                                                <div style={{fontSize: '13px', color: '#666'}}>
                                                                    Rp 8.000.000 (unit tenor 48 bulan DP mulai di Rp 24.000.000) (266.000 per hari)
                                                                </div>
                                                            </div>
                                                        </Radio>
                                                    </Space>
                                                </div>

                                                {/* VFE34 Section */}
                                                <div style={{
                                                    backgroundColor: '#fff',
                                                    padding: '15px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #e6e6e6'
                                                }}>
                                                    <div style={{
                                                        fontSize: '16px',
                                                        fontWeight: 600,
                                                        color: '#384967',
                                                        marginBottom: '10px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px'
                                                    }}>
                                                        VFE 34
                                                        <a 
                                                            href="https://amartavinfast.com/variant/VFE34_4X2_AT_WI_BAT" 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                fontSize: '12px',
                                                                color: '#1890ff',
                                                                textDecoration: 'none'
                                                            }}
                                                        >
                                                            (Lihat Produk)
                                                        </a>
                                                    </div>
                                                    <Space direction="vertical" style={{width: '100%'}}>
                                                        <Radio value="VFE34_SEWA_PER_BULAN">
                                                            <div style={{fontSize: '14px', color: '#384967', lineHeight: '1.5'}}>
                                                                <div style={{fontWeight: 500}}>SEWA PER BULAN</div>
                                                                <div style={{fontSize: '13px', color: '#666'}}>
                                                                    Rp 8.500.000 (deposit 1 bulan di depan) (280.000 per hari)
                                                                </div>
                                                            </div>
                                                        </Radio>
                                                        <Radio value="VFE34_SEWA_MILIK">
                                                            <div style={{fontSize: '14px', color: '#384967', lineHeight: '1.5'}}>
                                                                <div style={{fontWeight: 500}}>SEWA MILIK</div>
                                                                <div style={{fontSize: '13px', color: '#666'}}>
                                                                    Rp 9.500.000 (tenor 48 bulan DP mulai di Rp 34.000.000) (266.000 per hari)
                                                                </div>
                                                            </div>
                                                        </Radio>
                                                    </Space>
                                                </div>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>

                            <Divider orientation="left" plain>
                                <span style={{fontSize: '16px', color: '#384967', fontWeight: 500}}>Dokumen Pendukung</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 24}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 20}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`small-text-grey`}>Upload Gambar Pendapatan Mingguan Terbaru *</i><br/>
                                        <Upload
                                            method="POST"
                                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                                            maxCount={1}
                                            data={{
                                                document_name: (Math.random() + 1).toString(36).substring(7),
                                                company: "amarta",
                                                document_type: "driver_income",
                                            }}
                                            name="image"
                                            onChange={this.uploadImageChange}
                                            style={{width: '100%'}}
                                            listType="picture"
                                        >
                                            <Button icon={<UploadOutlined/>} loading={this.state.isUploading}>
                                                Upload Bukti Pendapatan
                                            </Button>
                                        </Upload>
                                        
                                        {this.state.pendapatanMingguanUrl ? (
                                            <div style={{marginTop: 10}}>
                                                <div style={{color: 'green', marginBottom: 5}}>✓ Gambar berhasil diunggah</div>
                                                <img src={this.state.pendapatanMingguanUrl} alt="Bukti Pendapatan" style={{maxWidth: '100%', maxHeight: '200px'}} />
                                            </div>
                                        ) : null}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider />
                            
                            <Button 
                                onClick={this.onSubmitForm} 
                                loading={this.state.isSubmitting} 
                                style={{backgroundColor: '#384967', width: "160px", borderColor: '#384967', color: '#fff'}} 
                                danger
                                disabled={!this.state.lat || !this.state.lng}
                            >
                                Simpan Form
                            </Button>
                            {(!this.state.lat || !this.state.lng) && (
                                <span style={{marginLeft: '10px', color: '#ff4d4f', fontSize: '12px'}}>
                                    Mohon izinkan akses lokasi terlebih dahulu
                                </span>
                            )}
                        </Form>
                    </Col>
                </Row>

                <div style={{minHeight: 100}}/>
                <FooterSection/>
            </>
        );
    }
}

export default withRouter(FormEvTaxi);
